import React from 'react';
import withSplashMessage from '../../splashMessage/withSplashMessage';
import withTracker from '../../withTracker';
import DesktopBg from '../../../svg/DesktopBg.js';
import MobileBg from '../../../svg/MobileBg.js';
import OnboardingStepNew from './OnboardingStepNew.js';
import Begin from './Begin.js';
import Zip from './Zip.js';
import OutOfArea from './OutOfArea.js';
import Chef from './Chef.js';
import StartDate from './StartDate.js';
import Portion from './Portion.js';
import Menu from './Menu.js';
import Diet from './Diet.js';
import Allergens from './Allergens.js';
import OtherAllergens from './OtherAllergens.js';
import SpecialInstructions from './SpecialInstructions.js';
import AlmostDone from './AlmostDone.js';
import YourDetails from './YourDetails.js';
import Password from './Password.js';
import Address from './Address.js';
import Billing from './Billing.js';
import BillingAddress from './BillingAddress.js';
import Reference from './Reference.js';
import EstimatedPrice from './EstimatedPrice.js';
import Finish from './Finish.js';
import { menuSelectionMaxQuantity, breakpoints } from '../../../const';
import CaretLeft from '../../../svg/CaretLeft.js';
import { onBoardingAPI } from '../../../InterfaceAPI/onboardingAPI';
import { stringfyServerErrors } from '../../../helpers/util';
import { menuAPI } from '../../../InterfaceAPI/menuAPI';
import MenuSelectionNew from '../MenuSelectionNew';
import { generateMenuSelections } from '../../../helpers/menuSelection';
import moment from 'moment';
import MenuFixedCounterSelect from '../MenuFixedCounterSelect';
import MenuSelectionConfirm from '../MenuSelectionConfirm';
import CustomizeDish from '../CustomizeDish';
import OpacityLayer from '../OpacityLayer';
import MenuFixedConfirmSelection from '../MenuFixedConfirmSelection';
import { portionSwitch } from '../../../masks';

class ClientOnboardingNew extends React.Component {
  stepsInitialState = [
    { component: Begin, isValid: true, buttonText: "Let's Begin" },
    { component: Zip, isValid: false },
    { component: Chef, isValid: false },
    { component: StartDate, isValid: true },
    { component: Menu, isValid: true, buttonText: 'Skip for now' },
    { component: Portion, isValid: false },
    { component: Diet, isValid: true },
    { component: Allergens, isValid: true },
    { component: OtherAllergens, isValid: true },
    { component: SpecialInstructions, isValid: true },
    { component: AlmostDone, isValid: true },
    { component: YourDetails, isValid: false },
    { component: Password, isValid: false },
    { component: Address, isValid: false },
    { component: Billing, isValid: false },
    { component: BillingAddress, isValid: true },
    { component: Reference, isValid: false },
    { component: EstimatedPrice, isValid: true },
    { component: Finish, isValid: false, buttonText: 'Login' },
  ];

  // For testing - all buttons enabled with isValid: true
  // stepsInitialState = [
  //   { component: Begin, isValid: true, buttonText: "Let's Begin" },
  //   { component: Zip, isValid: true },
  //   { component: Chef, isValid: true },
  //   { component: StartDate, isValid: true },
  //   { component: Menu, isValid: true, buttonText: 'Skip for now' },
  //   { component: Portion, isValid: true },
  //   { component: Diet, isValid: true },
  //   { component: Allergens, isValid: true },
  //   { component: OtherAllergens, isValid: true },
  //   { component: SpecialInstructions, isValid: true },
  //   { component: AlmostDone, isValid: true },
  //   { component: YourDetails, isValid: true },
  //   { component: Password, isValid: true },
  //   { component: Address, isValid: true },
  //   { component: Billing, isValid: true },
  //   { component: BillingAddress, isValid: true },
  //   { component: Reference, isValid: true },
  //   { component: EstimatedPrice, isValid: true },
  //   { component: Finish, isValid: true, buttonText: 'Login' }
  // ];

  state = {
    steps: this.stepsInitialState,
    client: {
      zip_code: '',
      client_service_preferences: [
        {
          start_time: '',
          day_of_week: '',
        },
      ],
      service_start_date: '',
      portion_size: '',
      allergen_tags: [],
      other_allergens: '',
      dietary_preference_tags: [],
      service_addresses: [
        {
          street_address: '',
          street_address_continued: '',
          city: '',
          state: '',
          zip_code: '',
        },
      ],
      refer: '',
      code: '', // promo code
      payment: {
        // cc_number: '4111111111111111',
        // expiration_date: '2020-05',
        // code: '111',
        // address: '4320 Monterrey Road',
        // city: 'Los Angeles',
        // state: 'CA',
        // zip_code: '90027'
      },
      special_instructions: '',
      accepted_terms_and_conditions: false,
    },
    currentStep: 0,
    isValid: true,
    hasSubmitted: false,
    availableAllergens: [],
    availableDiets: [],
    isZipServiceable: true,
    isMenuSelectShown: null, // starts null so menu slide doesn't happen on page load.  After first toggle it's true/false
    isMenuSelectionConfirmShown: null, // starts null so menu slide doesn't happen on page load.  After first toggle it's true/false
    menu: {},
    menu_selections: [],
    numDishesSelected: 0,
    isCustomizeDishShown: null, // starts null so menu slide doesn't happen on page load.  After first toggle it's true/false
    menuSelectionToCustomize: {},
    menuSelectionIndexToCustomize: null,
    special_instructions: '',
    hasSubmittedMenu: false,
    evergreenMenus: [],
  };

  render() {
    const {
      client,
      currentStep,
      steps,
      hasSubmitted,
      availableAllergens,
      availableDiets,
      isZipServiceable,
      isMenuSelectShown,
      isMenuSelectionConfirmShown,
      menu,
      menu_selections,
      numDishesSelected,
      isCustomizeDishShown,
      menuSelectionToCustomize,
      menuSelectionIndexToCustomize,
      special_instructions,
      evergreenMenus,
    } = this.state;
    const { windowWidth, location } = this.props;
    const { service_start_date = '' } = client;

    let buttonText = steps[currentStep].buttonText
      ? steps[currentStep].buttonText
      : 'Next';

    const isOpacityLayerShown =
      isMenuSelectShown || isMenuSelectionConfirmShown || isCustomizeDishShown;

    // For desktop
    const component = isZipServiceable
      ? steps[currentStep].component
      : OutOfArea;

    // Check whether there is a live menu for selected start date (no live menus beyond 4 weeks )
    const startDate = moment(service_start_date);
    const availableMenusEndpoint = moment().endOf('week').add(3, 'weeks');
    const isMenuAvailable = startDate.isSameOrBefore(availableMenusEndpoint);

    // Each screen is 1/19th of total width of steps (5.263%)
    const stepsStyles = {
      transform: `translateX(-${currentStep * 5.263}%)`,
    };

    const isDesktop = windowWidth > breakpoints.tablet;

    // For mobile
    // Replace step 4 with out of area component is zip not serviceable.  Keep length the same for slide transitions to remain correct
    const adjustedSteps = isZipServiceable
      ? steps
      : [...steps.slice(0, 2), { component: OutOfArea }, ...steps.slice(3, 19)];

    return (
      <div>
        <OpacityLayer
          isShown={isOpacityLayerShown}
          handleOnClick={this.closeLeftSideScreens}
        />
        {windowWidth < breakpoints.iphone ? <MobileBg /> : <DesktopBg />}
        <div className="onboarding-new__container">
          <div className="onboarding-new__navbar">
            {this.renderBackButton()}

            {/* skip ahead button for development only */}
            {/* <button onClick={this.handleButtonClick} className="temp-button">
              &gt;
            </button> */}

            {this.renderPageCount()}
          </div>

          {!isDesktop ? (
            <div className="onboarding-new__steps" style={stepsStyles}>
              {adjustedSteps.map((step, ix) => (
                <OnboardingStepNew
                  Component={step.component}
                  updateClient={this.updateClient}
                  client={client}
                  setStepAsValid={(isCurrentStep) =>
                    this.handleSetStepValidity(true, isCurrentStep)
                  }
                  setStepAsInvalid={(isCurrentStep) =>
                    this.handleSetStepValidity(false, isCurrentStep)
                  }
                  currentStep={currentStep}
                  index={ix}
                  isCurrentStep={currentStep === ix}
                  hasSubmitted={hasSubmitted}
                  availableAllergens={availableAllergens}
                  availableDiets={availableDiets}
                  submitClient={this.submitClient}
                  checkZip={this.checkZip}
                  lookupMenu={this.lookupMenu}
                  showMenu={() => this.setState({ isMenuSelectShown: true })}
                  isMenuAvailable={isMenuAvailable}
                />
              ))}
            </div>
          ) : (
            <OnboardingStepNew
              Component={component}
              updateClient={this.updateClient}
              client={client}
              setStepAsValid={() => this.handleSetStepValidity(true, true)}
              setStepAsInvalid={() => this.handleSetStepValidity(false, true)}
              currentStep={currentStep}
              isCurrentStep={true}
              hasSubmitted={hasSubmitted}
              availableAllergens={availableAllergens}
              availableDiets={availableDiets}
              submitClient={this.submitClient}
              checkZip={this.checkZip}
              lookupMenu={this.lookupMenu}
              showMenu={() => this.setState({ isMenuSelectShown: true })}
              isMenuAvailable={isMenuAvailable}
            />
          )}

          {isZipServiceable && (
            <button
              onClick={this.handleButtonClick}
              className="new-btn new-btn--full-mobile new-btn--solid-green onboarding-new__next-button"
              disabled={!steps[currentStep].isValid}
              aria-label="submit fields and proceed to next screen"
            >
              {buttonText}
            </button>
          )}

          <MenuSelectionNew
            isOpen={isMenuSelectShown}
            handleClose={this.closeLeftSideScreens}
            updateMenuSelection={this.updateMenuSelection}
            menuSelections={menu_selections}
            menu={menu}
            handleCustomizeDish={this.handleCustomizeDish}
            menuStartTime={service_start_date}
            evergreenMenus={evergreenMenus}
          />

          <MenuFixedCounterSelect
            numDishesSelected={numDishesSelected}
            handleSelectDishes={this.handleSelectDishes}
            isShown={isMenuSelectShown}
          />

          <MenuSelectionConfirm
            isOpen={isMenuSelectionConfirmShown}
            menuStartTime={service_start_date}
            menu={menu}
            handleClose={this.closeLeftSideScreens}
            menuSelections={menu_selections}
            handleBackToEdit={this.backToEdit}
            specialInstructions={special_instructions}
            handleSubmit={this.handleMenuConfirmSubmit}
            handleChange={this.handleChange}
            location={location}
          ></MenuSelectionConfirm>

          <MenuFixedConfirmSelection
            handleSelectDishes={this.handleSelectDishes}
            isShown={isMenuSelectionConfirmShown}
          />

          <CustomizeDish
            isOpen={isCustomizeDishShown}
            handleClose={this.handleCustomizeDishClose}
            menuSelection={menuSelectionToCustomize}
            handleCustomizeSubmit={this.handleCustomizeSubmit}
            updateMenuSelection={this.updateMenuSelection}
            index={menuSelectionIndexToCustomize}
            numDishesSelected={numDishesSelected}
            client={client}
          />
        </div>
      </div>
    );
  }

  handleSetStepValidity = (bool, isCurrentStep) => {
    if (isCurrentStep) {
      this.setState((state) => {
        const steps = state.steps.map((step, i) => {
          if (state.currentStep === i) {
            return { ...step, isValid: bool };
          } else {
            return step;
          }
        });
        return {
          steps,
        };
      });
    }
  };

  renderBackButton = () => {
    const { currentStep } = this.state;
    return (
      currentStep > 0 && (
        <button
          onClick={this.decrementStep}
          className="onboarding-new__nav-button"
        >
          <CaretLeft />
        </button>
      )
    );
  };

  renderPageCount = () => {
    const { currentStep, steps, isZipServiceable } = this.state;

    // Dont show if zip not serviceable
    return (
      currentStep > 0 &&
      isZipServiceable && (
        <div className="onboarding-new__nav-button">
          {`${currentStep}/${steps.length - 1}`}
        </div>
      )
    );
  };

  handleButtonClick = () => {
    const { currentStep } = this.state;
    // When not zip code screen (1).  For Zip screen handle submit and increment after checking if zip serviceable
    const callback = currentStep !== 1 ? this.incrementStep : null;

    this.markAsSubmitted(callback);
  };

  markAsSubmitted = (callback = this.incrementStep) => {
    // hasSubmitted flag change triggers updateClient, etc in each screen.  Then gets reset
    this.setState({ hasSubmitted: true }, callback);

    setTimeout(() => {
      this.setState({ hasSubmitted: false });
    }, 1000);
  };

  incrementStep = () => {
    const { currentStep, steps } = this.state;

    if (currentStep !== steps.length - 1) {
      this.setState({
        currentStep: currentStep + 1,
      });
    }
  };

  decrementStep = () => {
    const { currentStep, isZipServiceable } = this.state;
    const newStep = isZipServiceable ? currentStep - 1 : 1;
    // if on zip not serviceable back button takes you back to zip screen (1)
    this.setState({
      isZipServiceable: true,
      currentStep: newStep,
    });
  };

  updateClient = (updatedClient, cb = () => {}) => {
    // update the client
    const client = { ...this.state.client, ...updatedClient };
    this.setState({ client }, cb);
  };

  // to be called in final step of on boarding
  submitClient = () => {
    // mutate payload
    const client = this.mutateClientPayload({ ...this.state.client });
    // todo: sample payload... leaving here for now.
    // const client = {
    //     "accepted_terms_and_conditions": true,
    //     "email": "david@wondersauce.com",
    //     "first_name": "First",
    //     "last_name": "Last",
    //     "notes": "I don't eat bananas.",
    //     "password": "B@r3Minimum!",
    //     "password_confirmation": "B@r3Minimum!",
    //     "phone_number": "1-203-867-5309",
    //     "portion_size": "small",
    //     "redirect_url": "http://localhost:5000",
    //     "service_start_date": "Fri, 01 Apr 2022",
    //     "stripe_token": "tok_visa",
    //     "service_addresses": [{
    //         "street_address": "205 1st Avenue",
    //         "street_address_continued": "Apartment 3",
    //         "city": "New York",
    //         "state": "NY",
    //         "zip_code": "10010"
    //     }],
    //     "client_service_preferences": [{
    //         "start_time": "08:00",
    //         "day_of_week": 'thursday'
    //     }]
    // };

    // client.payment =  {
    //   cc_number: "4111111111111111",
    //   expiration_date: "2020-05",
    //   code: "111",
    //
    //   city: "New York",
    //   state: "NY",
    //   address: "1 Main Street",
    //   zip_code: "10000"
    // };

    onBoardingAPI
      .createClient(client)
      .then(({ errors, messages, client }) => {
        if (messages)
          this.props.addMessage({
            className: 'error',
            message: messages.join(', '),
          });

        this.props.history.push({ pathname: '/login' });
      })
      .catch((err) =>
        this.props.addMessage({
          className: 'error',
          message: stringfyServerErrors(err),
        })
      );
  };

  mutateClientPayload = (client) => {
    const { menu_selections } = this.state;

    if (client.client_service_preferences.length) {
      client.client_service_preferences[0] = {
        ...client.client_service_preferences[0],
        start_date: client.service_start_date,
      };
    }

    // only include selections made.  Add a default portion value to selections without one
    client.menu_selections = menu_selections
      .filter((item) => item.quantity > 0)
      .map((item) => {
        return {
          ...item,
          portion: item.portion
            ? item.portion
            : `${portionSwitch(client.portion_size)}.0`,
        };
      });

    return client;
  };

  checkZip = (updatedClient) => {
    const { zip_code } = updatedClient;
    // 10010 - yes
    // 07020 - maybe
    // 00000 - no
    onBoardingAPI
      .isServiceable(zip_code)
      .then((data) => {
        const { serviceability_status } = data.data;
        const isZipServiceable =
          serviceability_status === 'SERVICEABLE' ? true : false;

        this.setState({ isZipServiceable }, this.markAsSubmitted);
      })
      .catch((err) => console.error('error:', err)); // todo: error handling
  };

  getServiceWeek = (date) => moment(date).day(0).format('YYYY-MM-DD');

  lookupMenu = () => {
    const { client } = this.state;
    const service_week = this.getServiceWeek(client.service_start_date);

    onBoardingAPI
      .lookupMenus()
      .then(({ menus }) => {
        // load the menu
        const menu =
          menus.find((menu) => menu.service_week === service_week) || {};

        let menu_selections = [];
        if (menu && menu.courses)
          menu_selections = generateMenuSelections(menu);

        this.setState({
          menu_selections,
          menu,
        });
      })
      .catch((err) => {
        console.log(err);
        // this.props.addMessage({
        //   className: 'error',
        //   message: stringfyServerErrors(err)
        // });
      });
  };

  updateMenuSelection = (index, menuSelection) => {
    const { menu_selections = [] } = this.state;

    // if it's not in there, throw it at the end
    const updatedMenuSelections =
      index === -1
        ? [...menu_selections, menuSelection]
        : // if it is, updated it.
          [
            ...menu_selections.slice(0, index),
            { ...menuSelection },
            ...menu_selections.slice(index + 1, menu_selections.length),
          ];

    const total = this.calcTotalSelections(updatedMenuSelections);
    if (total <= menuSelectionMaxQuantity) {
      this.setState({
        menu_selections: updatedMenuSelections,
        numDishesSelected: total,
        isCustomizeDishShown: null,
      });
    }
  };

  calcTotalSelections = (menuSelections = this.state.menu_selections) => {
    return menuSelections.reduce(
      (accum, selection) => selection.quantity + accum,
      0
    );
  };

  handleSelectDishes = () => {
    this.setState({
      isMenuSelectionConfirmShown: true,
    });
  };

  backToEdit = () => {
    this.setState({
      isMenuSelectionConfirmShown: false,
      isMenuSelectShown: true,
    });
  };

  closeLeftSideScreens = () => {
    this.setState({
      isSkipConfirmationShown: false,
      isMenuSelectShown: false,
      isMenuSelectionConfirmShown: false,
    });
  };

  handleCustomizeDish = (e, dish, index) => {
    e.stopPropagation();
    this.setState({
      isCustomizeDishShown: true,
      menuSelectionToCustomize: dish,
      menuSelectionIndexToCustomize: index,
    });
  };

  handleCustomizeSubmit = (index, menuSelection) => {
    const { menu_selections } = this.state;
    // find index to be updated in menuSelections. Selected items from other menus/favs will already be added to menuSelections Array
    const menuSelectionsIndex = menu_selections.findIndex(
      (el) => el.dish_id === menuSelection.dish_id
    );

    this.updateMenuSelection(menuSelectionsIndex, menuSelection);
    this.handleCustomizeDishClose();
  };

  closeMenuSelectionConfirm = () => {
    this.setState({
      isMenuSelectionConfirmShown: false,
      isMenuSelectShown: false,
    });
  };

  handleCustomizeDishClose = () => {
    this.setState({ isCustomizeDishShown: false });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleMenuConfirmSubmit = () => {
    const { currentStep, steps } = this.state;

    // remove button text ("Skip for now") from current step.  Will fallback to "Next".
    const newSteps = [...steps];
    const updatedStep = newSteps[currentStep];
    delete updatedStep.buttonText;
    newSteps[currentStep] = updatedStep;

    this.closeLeftSideScreens();
    this.setState({
      hasSubmittedMenu: true,
      steps: [...newSteps],
    });
  };

  loadMenus = () => {
    // Evergreen
    menuAPI
      .getEvergreenMenus()
      .then(({ menus }) => {
        this.setState({ evergreenMenus: menus });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  componentDidMount() {
    // Get allergen options for Allergens screen
    menuAPI
      .getAllergens()
      .then(({ allergen_tags: availableAllergens }) =>
        this.setState({ availableAllergens })
      )
      .catch((error) => console.log(error));

    // Get diet options for Diet screen
    menuAPI
      .getDiets()
      .then(({ dietary_preference_tags: availableDiets }) =>
        this.setState({ availableDiets })
      )
      .catch((result) => console.log(result));

    // Get Evergreen menus
    this.loadMenus();
  }
}
export default withSplashMessage(withTracker(ClientOnboardingNew));



// WEBPACK FOOTER //
// ./src/components/new/onboarding/ClientOnboardingNew.js